import { FormField, RadioGroup, Textarea, TextField } from "@smooth/design-system-components"
import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form"
import { CALLER_TYPE_LABELS, CALLER_TYPES, CallerType, IncomingCallLogFormValues } from "../types"
import { IncomingCallLogStoreSelect } from "./IncomingCallLogStoreSelect"
import { IncomingCallLogUserSelect } from "./IncomingCallLogUserSelect"

const CALLER_TYPE_OPTIONS = CALLER_TYPES.map((value) => ({
  value,
  label: CALLER_TYPE_LABELS[value],
}))

type Props = {
  control: Control<IncomingCallLogFormValues>
  register: UseFormRegister<IncomingCallLogFormValues>
  errors: FieldErrors<IncomingCallLogFormValues>
}

/** 受電ログの追加・編集で共通の入力欄 */
export const IncomingCallLogFormFields: React.FC<Props> = ({ control, register, errors }) => (
  <>
    <FormField label="電話をかけてきた相手" required error={errors.callerType?.message}>
      <Controller
        control={control}
        name="callerType"
        render={({ field }) => (
          <RadioGroup
            name="incoming-call-log-caller-type"
            appearance="chip"
            options={CALLER_TYPE_OPTIONS}
            value={field.value}
            onChange={(value) => field.onChange(value as CallerType)}
          />
        )}
      />
    </FormField>
    <FormField
      label="相手の付属情報"
      hint="任意。店舗の担当者名、ユーザー本人以外からの電話ならその人の名前など"
      error={errors.callerNote?.message}
    >
      <TextField {...register("callerNote")} error={!!errors.callerNote} />
    </FormField>
    <div className="flex gap-4">
      <div className="flex-1">
        <Controller
          control={control}
          name="userId"
          render={({ field }) => (
            <FormField label="ユーザー" hint="任意" error={errors.userId?.message}>
              <IncomingCallLogUserSelect
                value={field.value}
                onChange={field.onChange}
                error={!!errors.userId}
              />
            </FormField>
          )}
        />
      </div>
      <div className="flex-1">
        <Controller
          control={control}
          name="storeId"
          render={({ field }) => (
            <FormField label="店舗" hint="任意" error={errors.storeId?.message}>
              <IncomingCallLogStoreSelect
                value={field.value}
                onChange={field.onChange}
                error={!!errors.storeId}
              />
            </FormField>
          )}
        />
      </div>
    </div>
    <FormField label="受電日時" required error={errors.receivedAt?.message}>
      <TextField type="datetime-local" {...register("receivedAt")} error={!!errors.receivedAt} />
    </FormField>
    <FormField label="会話の内容" required error={errors.content?.message}>
      <Textarea rows={6} {...register("content")} error={!!errors.content} />
    </FormField>
    <FormField label="ネクストアクション" hint="なければ空欄" error={errors.nextAction?.message}>
      <Textarea rows={3} {...register("nextAction")} error={!!errors.nextAction} />
    </FormField>
  </>
)
